import React from 'react';
import { arrayOf, shape, number, string, node } from 'prop-types';
import { Chip } from '../../..';
import { SkillsWrapper } from '../../Activity.styles';
export const SkillsRead = _ref => {
  let {
    data: {
      skillset
    },
    editButton
  } = _ref;
  const renderChips = () => skillset.map(_ref2 => {
    let {
      name,
      id
    } = _ref2;
    return /*#__PURE__*/React.createElement(Chip, {
      label: name,
      id: id,
      key: id
    });
  });
  return /*#__PURE__*/React.createElement(SkillsWrapper, null, editButton || null, /*#__PURE__*/React.createElement("h4", {
    className: "headline"
  }, "Skills"), renderChips());
};
SkillsRead.propTypes = {
  data: shape({
    skillset: arrayOf(shape({
      id: number,
      name: string
    }).isRequired).isRequired
  }).isRequired,
  editButton: node
};
SkillsRead.defaultProps = {
  editButton: undefined
};